// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3XxA5","notes":"Notes_notes__I5hpT"};